// extracted by mini-css-extract-plugin
module.exports = {"out_wrapper":"Monitor_out_wrapper__lw3GW","wrapper":"Monitor_wrapper__23XmV","tab_close":"Monitor_tab_close__2dov6"};